module.exports = __webpack_public_path__ + "assets/money-circle.5067e807.svg";